import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types';

const ProgressBar = () => {
  const [progress, setProgress] = useState(0);
  const uploadingProgress = () => {
    const progressGrowSize = 10;
    const delayGrowFactor = .1;
    let delay = 1000;
    let fakeProgress = 0;
    let timerId = setTimeout(function request() {
      fakeProgress += progressGrowSize;
      setProgress(fakeProgress);
      if (fakeProgress < 100) {
        delay *= delayGrowFactor;
        timerId = setTimeout(request, delay);
      } else {
        clearTimeout(timerId);
      }
    }, delay);
  };

  useEffect(() => {
    uploadingProgress();
  }, []);

    return (
        <div className="progressBarContainer">
            <div
                className="progressBarCondition"
                style={{width: `${progress}%`}}
            />
        </div>
    )
};

ProgressBar.propTypes = {
  progress: PropTypes.number,
};

export default ProgressBar;
